import { message } from "antd";

/**
 * Displays a message with the specified type and content.
 * @param {('success' | 'error' | 'info' | 'warning')} type - Type of the message.
 * @param {string} content - Content of the message.
 */
export const showMessage = ({ type, content }) => {
  message[type](content);
};
